export default __webpack_public_path__ + "static/The Backdrop_image 6_map@2x-9827bbb76788c70f5a88873bd9c6f91e.png";